export default "__VITE_ASSET__dhfk2ZaZ__"